import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { LogoutService } from '../services/logout.service';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { SKIP_AUTH } from 'juboo-result';

@Injectable()
export class httpCustomInterceptor implements HttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    handler: HttpHandler
  ): Observable<HttpEvent<any>> {

    // External presigned URL: do not touch any header.
    // The URL check also covers the case where the SKIP_AUTH token instance
    // differs between the library (dist) and the application (double bundle).
    const isS3Download =
      req.context.get(SKIP_AUTH) ||
      req.url.includes('X-Amz-Signature');

    if (isS3Download) {
      return handler.handle(req);
    }

    const browserLang = this.getBrowserLanguage();
    const supportedLanguages = ['en', 'fr'];
    const defaultLang = 'fr';

    const lang = supportedLanguages.includes(browserLang)
      ? browserLang
      : defaultLang;

    const logoutService = inject(LogoutService);
    const token = localStorage.getItem('authenticationToken') ?? '';

    const headers: Record<string, string> = {
      'X-Lang': lang,
      'Request-Origin': 'CLIENT',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    req = req.clone({
      setHeaders: headers
    });

    return handler.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          logoutService.logout();
        }

        return throwError(() => error);
      })
    );
  }

  private getBrowserLanguage(): string {
    const navigatorLang =
      navigator.language || (navigator as any).userLanguage;

    return navigatorLang
      ? navigatorLang.split('-')[0]
      : 'fr';
  }
}